import React, { forwardRef, Suspense } from 'react';

import AuthShow from '~/components/AuthShow';
import BodyRender from '~/components/BodyRender';

import { RegisteredWrapperProps } from './models';

const RegisteredWrapper = forwardRef<HTMLDivElement, RegisteredWrapperProps>(
  ({ hideFor, body, rteImages, currentPageUid }, ref) => {
    const forSignedIn = hideFor === 'non_authorized';
    const forSignedOut = hideFor === 'authorized';

    const content = (
      <div ref={ref}>
        <Suspense fallback={null}>
          <BodyRender
            items={body}
            currentPageUid={currentPageUid}
            externalData={{ jsonRTEImages: rteImages }}
          />
        </Suspense>
      </div>
    );

    if (!hideFor) {
      return content;
    }

    return (
      <AuthShow forSignedIn={forSignedIn} forSignedOut={forSignedOut}>
        {content}
      </AuthShow>
    );
  }
);

export default RegisteredWrapper;
